import { createJSONRequest } from './create-request'

export const fetchDeepDiveReports = () => createJSONRequest({
  url: '/api/deep-dive-reports',
  method: 'GET',
})

export const fetchDeepDiveReport = (year: number) => createJSONRequest({
  url: `/api/deep-dive-reports/${year}`,
  method: 'GET',
})

export const getDeepDiveFullPdfUrl = (year: number) => createJSONRequest({
  url: `/api/deep-dive-reports/${year}/download/full-pdf`,
  method: 'GET',
})

export const getDeepDiveSlideDeckUrl = (year: number) => createJSONRequest({
  url: `/api/deep-dive-reports/${year}/download/slide-deck`,
  method: 'GET',
})
